@if (isDepartmentsUpdateEnabled()) {
  <div
    class="h-full flex flex-col"
    [class]="floatingPageClasses()"
    [class.gap-2xl]="!floating()"
    [class.gap-lg]="floating()">
    @if (floating()) {
      <div class="flex flex-wrap items-center justify-between gap-lg">
        <h5 class="text-neutral-900 font-semibold text-2xl">
          {{ 'department_list_screen_title' | transloco }}
        </h5>
        <ng-container [ngTemplateOutlet]="newDepartmentButton" />
      </div>
    } @else {
      <h5 class="text-neutral-900 font-semibold text-2xl">
        {{ 'department_list_screen_title' | transloco }}
      </h5>
    }

    <section
      [class]="
        floating() ? 'floating-card p-2xl flex flex-col gap-2xl' : 'contents'
      "
      [class.gap-lg]="isNewTableUi()"
      data-testid="departments-section">
      <!-- floating + Tables_new_design leaves this row empty, so drop it -->
      @if (!floating() || !isNewTableUi()) {
        <div class="flex flex-wrap items-center justify-between gap-lg">
          <div class="flex items-center gap-md">
            @if (!floating()) {
              <h6 class="text-lg font-semibold text-neutral-900">
                {{ 'department_list_screen_subtitle' | transloco }}
              </h6>
            }
          </div>
          <!-- Tables_new_design shows the search in the table toolbar instead -->
          @if (!isNewTableUi()) {
            <ng-container [ngTemplateOutlet]="departmentsSearch" />
          }
        </div>
      }

      @if (isNewTableUi()) {
        <!-- Tables_new_design: tab chips, then one toolbar row (search | view controls | menu) -->
        <div
          data-filter-chips
          class="flex min-w-0 items-center gap-sm overflow-x-auto [scrollbar-width:none]"
          role="tablist">
          @for (tab of stateTabs; track tab.key) {
            @let isActive = store.tab() === tab.key;
            <button
              type="button"
              role="tab"
              class="flex shrink-0 items-center gap-sm rounded-full border px-md py-sm text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              [class]="
                isActive
                  ? 'bg-neutral-900 border-neutral-900 text-white'
                  : 'bg-white border-neutral-200 text-neutral-900 hover:bg-neutral-50'
              "
              [attr.aria-selected]="isActive"
              [attr.data-testid]="'departments-tab-' + tab.key"
              (click)="store.setTab(tab.key)">
              <ng-container
                [ngTemplateOutlet]="tabIcon"
                [ngTemplateOutletContext]="{ $implicit: tab.key }" />
              {{ tab.label | transloco }}
              @if (isActive) {
                <span
                  class="font-normal text-neutral-300"
                  data-testid="departments-total">
                  {{ store.departmentsTotal() }}
                </span>
              }
            </button>
          }
        </div>

        @if (store.hasDepartmentsError()) {
          <ng-container [ngTemplateOutlet]="departmentsError" />
        } @else if (store.view() === 'list' || !store.visibleTree().length) {
          <!-- Stays mounted while loading so the search in its toolbar keeps focus -->
          <lib-department-tree-table
            [roots]="store.pagedRoots()"
            [expandedIds]="store.listExpandedIds()"
            [expandAll]="store.isListForceExpanded()"
            [loading]="store.isDepartmentsLoading()"
            [actionTemplate]="action"
            [searchTemplateRef]="departmentsSearch"
            [toolbarActionsTemplateRef]="viewControls"
            (toggleExpanded)="store.toggleListExpanded($event)"
            (selectDepartment)="store.selectDepartment($event.id)" />
        } @else {
          <div
            data-table-toolbar
            class="flex flex-wrap items-center justify-between gap-md">
            <div class="flex min-w-0 flex-1 items-center">
              <ng-container [ngTemplateOutlet]="departmentsSearch" />
            </div>
            <ng-container [ngTemplateOutlet]="viewControls" />
          </div>
          <ng-container [ngTemplateOutlet]="orgChart" />
        }
      } @else {
        <div
          class="flex flex-wrap items-end justify-between gap-lg border-b border-neutral-200">
          <div class="flex items-center gap-2xl" role="tablist">
            @for (tab of stateTabs; track tab.key) {
              <button
                type="button"
                role="tab"
                class="flex items-center gap-sm pb-md text-sm font-medium border-b-2 cursor-pointer"
                [class.border-primary-500]="store.tab() === tab.key"
                [class.text-primary-500]="store.tab() === tab.key"
                [class.border-transparent]="store.tab() !== tab.key"
                [class.text-neutral-500]="store.tab() !== tab.key"
                [attr.aria-selected]="store.tab() === tab.key"
                [attr.data-testid]="'departments-tab-' + tab.key"
                (click)="store.setTab(tab.key)">
                <ng-container
                  [ngTemplateOutlet]="tabIcon"
                  [ngTemplateOutletContext]="{ $implicit: tab.key }" />
                {{ tab.label | transloco }}
                @if (store.tab() === tab.key) {
                  <span
                    class="bg-primary-50 text-primary-700 rounded-2xl px-md py-x-sm text-xs font-medium"
                    data-testid="departments-total">
                    {{ store.departmentsTotal() }}
                  </span>
                }
              </button>
            }
          </div>

          <div class="flex items-center gap-md pb-md">
            <ng-container [ngTemplateOutlet]="viewControls" />

            @if (!floating()) {
              <ng-container [ngTemplateOutlet]="newDepartmentButton" />
            }
          </div>
        </div>

        @if (store.isDepartmentsLoading() && !store.departmentItems().length) {
          <div class="flex justify-center py-5xl">
            <lib-loader />
          </div>
        } @else if (store.hasDepartmentsError()) {
          <ng-container [ngTemplateOutlet]="departmentsError" />
        } @else if (store.view() === 'list' || !store.visibleTree().length) {
          <lib-department-tree-table
            [roots]="store.pagedRoots()"
            [expandedIds]="store.listExpandedIds()"
            [expandAll]="store.isListForceExpanded()"
            [actionTemplate]="action"
            (toggleExpanded)="store.toggleListExpanded($event)"
            (selectDepartment)="store.selectDepartment($event.id)" />
        } @else {
          <ng-container [ngTemplateOutlet]="orgChart" />
        }
      }
    </section>
  </div>

  <ng-template #departmentsSearch>
    <lib-search-field
      [placeholder]="'department_list_screen_search_placeholder' | transloco"
      (searchKeywordEmitter)="store.setSearch($event)" />
  </ng-template>

  <ng-template #tabIcon let-key>
    @switch (key) {
      @case ('all') {
        <lib-all-icon iconClass="size-5" />
      }
      @case ('active') {
        <lib-active-icon iconClass="size-5" />
      }
      @case ('inactive') {
        <lib-close-circle-icon iconClass="size-5" />
      }
    }
  </ng-template>

  <ng-template #viewControls>
    <div class="flex items-center gap-md">
      @if (store.view() === 'list') {
        <div class="flex items-center gap-sm">
          <button
            type="button"
            class="text-sm font-medium text-primary-600 p-sm cursor-pointer disabled:text-neutral-300 disabled:cursor-default"
            [disabled]="!store.canCollapseList()"
            data-testid="departments-collapse-all"
            (click)="store.collapseList()">
            {{ 'form_builder_collapse_all_button' | transloco }}
          </button>
          <button
            type="button"
            class="text-sm font-medium text-primary-600 p-sm cursor-pointer disabled:text-neutral-300 disabled:cursor-default"
            [disabled]="!store.canExpandList()"
            data-testid="departments-expand-all"
            (click)="store.expandList()">
            {{ 'form_builder_expand_all_button' | transloco }}
          </button>
        </div>
      }

      <div
        class="flex rounded-md bg-neutral-100 p-x-sm"
        [class.h-9]="isNewTableUi()"
        role="group">
        <button
          type="button"
          class="flex items-center gap-sm px-md rounded-sm text-xs font-medium cursor-pointer"
          [class.py-sm]="!isNewTableUi()"
          [class.bg-white]="store.view() === 'orgChart'"
          [class.text-primary-500]="store.view() === 'orgChart'"
          [class.text-neutral-500]="store.view() !== 'orgChart'"
          [attr.aria-pressed]="store.view() === 'orgChart'"
          data-testid="departments-view-org-chart"
          (click)="store.view.set('orgChart')">
          <lib-org-chart-icon iconClass="size-5" />
        </button>
        <button
          type="button"
          class="flex items-center gap-sm px-md rounded-sm text-xs font-medium cursor-pointer"
          [class.py-sm]="!isNewTableUi()"
          [class.bg-white]="store.view() === 'list'"
          [class.text-primary-500]="store.view() === 'list'"
          [class.text-neutral-500]="store.view() !== 'list'"
          [attr.aria-pressed]="store.view() === 'list'"
          data-testid="departments-view-list"
          (click)="store.view.set('list')">
          <lib-row-icon iconClass="size-5" />
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #departmentsError>
    <div
      class="flex flex-col items-center gap-md py-5xl text-sm text-neutral-700"
      role="alert"
      data-testid="departments-error">
      <p>{{ 'department_list_screen_load_error' | transloco }}</p>
      <button
        type="button"
        class="py-sm px-2xl rounded-md bg-primary-500 text-white font-medium cursor-pointer"
        (click)="store.loadDepartments()">
        {{ 'department_retry_button' | transloco }}
      </button>
    </div>
  </ng-template>

  <ng-template #orgChart>
    <lib-department-org-chart
      [roots]="store.visibleTree()"
      [expandedIds]="store.chartExpandedIds()"
      [positionForests]="store.positionForests()"
      (toggleExpanded)="store.toggleChartExpanded($event)"
      (selectDepartment)="store.selectDepartment($event.id)" />
  </ng-template>

  <ng-template #newDepartmentButton>
    <a
      class="flex items-center bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm"
      [routerLink]="[`${ADMIN_ROUTES.DEPARTMENTS.FORM}` | tenantPath: 'admin']"
      id="department_list_screen_new_department_button">
      <lib-add-icon [iconClass]="'size-5 text-white'" />
      <span class="hidden md:block">
        {{ 'department_list_screen_new_department_button' | transloco }}
      </span>
    </a>
  </ng-template>

  @if (store.selectedDepartment(); as department) {
    <lib-off-canvas
      [title]="department.name"
      [showTitle]="false"
      [width]="'32'"
      (hide)="store.closeQuickView()">
      <div offCanvasHeader class="flex items-center gap-lg min-w-0">
        @if (department.image?.url) {
          <img
            [src]="department.image.url"
            [alt]="department.name"
            width="64"
            height="64"
            class="size-16 rounded-md object-cover shrink-0"
            data-testid="quick-view-avatar" />
        } @else {
          <div
            class="size-16 rounded-md bg-primary-50 text-primary-500 text-2xl font-medium flex items-center justify-center shrink-0"
            data-testid="quick-view-avatar">
            {{ department.name | avatar }}
          </div>
        }

        <div class="flex flex-col gap-sm min-w-0">
          <div class="flex items-center gap-sm min-w-0">
            <p class="text-xl font-semibold text-neutral-900 truncate">
              {{ department.name }}
            </p>
            @if (department.state) {
              <span class="text-lg font-semibold text-neutral-300">|</span>
              <lib-badge
                [label]="department.state.label"
                [badgeClass]="
                  'px-sm border-none text-xs font-medium text-white ' +
                  (department.state.value | userStatus)
                "
                data-testid="quick-view-status" />
            }
          </div>
          <span
            class="text-xs font-medium text-neutral-500"
            data-testid="quick-view-identifier">
            # {{ department.identifier }}
          </span>
        </div>
      </div>

      <lib-department-quick-view [departmentId]="department.id" />
    </lib-off-canvas>
  }

  <ng-template #action let-row>
    <lib-action-list
      [parentName]="'department_tree_table'"
      [menuItems]="actionMenuItems()"
      (menuToggled)="selectedDepartment.set(row)"
      (itemClick)="handleAction($event, row)" />
  </ng-template>

  <ng-template #deactivate>
    <div class="text-center">
      <div
        class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
        <lib-close-square-icon
          viewBox="0 0 30 30"
          width="27"
          height="27"
          iconClass="text-destructive-500" />
      </div>
    </div>

    <p class="text-lg text-center font-medium mb-sm">
      {{ 'deactivate_department_modal_title' | transloco }}
    </p>

    <p class="text-sm text-neutral-500 text-center mb-4xl">
      {{ 'deactivate_department_modal_description' | transloco }}
      <span class="font-medium text-primary-500">
        {{ 'deactivate_department_modal_highlighted_description' | transloco }}
      </span>
    </p>

    <div class="flex flex-col gap-md text-base font-medium">
      <button
        [class.opacity-30]="isDepartmentStateLoading()"
        [disabled]="isDepartmentStateLoading()"
        (click)="deactivateDepartment()"
        class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
        {{
          'deactivate_department_modal_deactivate_department_button' | transloco
        }}
      </button>

      <button
        (click)="closeModal()"
        class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
        {{ 'deactivate_department_modal_no_keep_it_button' | transloco }}
      </button>
    </div>
  </ng-template>

  <ng-template #activate>
    <div class="text-center">
      <div
        class="inline-flex justify-center items-center bg-primary-50 p-sm rounded-full mb-xl img-width-container">
        <lib-tick-square-icon iconClass="size-8 text-primary-500" />
      </div>
    </div>

    <p class="text-lg text-center font-medium mb-sm">
      {{ 'activate_department_modal_title' | transloco }}
    </p>

    <p class="text-sm text-neutral-500 text-center mb-4xl">
      {{ 'activate_department_modal_description' | transloco }}
      <span class="font-medium text-primary-500 block">
        {{ 'activate_department_modal_highlighted_description' | transloco }}
      </span>
    </p>

    <div class="flex flex-col gap-md text-base font-medium">
      <button
        [disabled]="isDepartmentStateLoading()"
        (click)="activateDepartment()"
        class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
        {{ 'activate_department_modal_activate_department_button' | transloco }}
      </button>

      <button
        (click)="closeModal()"
        class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
        {{ 'activate_department_modal_cancel_button' | transloco }}
      </button>
    </div>
  </ng-template>

  <ng-template #deleteRecord>
    <div class="text-center">
      <div
        class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
        <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
      </div>
    </div>

    <p class="text-lg text-center font-medium mb-sm">
      {{ 'delete_department_modal_title' | transloco }}
    </p>

    <p class="text-sm text-neutral-500 text-center mb-4xl">
      {{ 'delete_department_modal_description' | transloco }}
    </p>

    <div class="flex flex-col gap-md text-base font-medium">
      <button
        [class.opacity-30]="isDepartmentStateLoading()"
        [disabled]="isDepartmentStateLoading()"
        (click)="deleteDepartment()"
        class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
        {{ 'delete_department_modal_delete_department_button' | transloco }}
      </button>

      <button
        (click)="closeModal()"
        class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
        {{ 'delete_department_modal_cancel_button' | transloco }}
      </button>
    </div>
  </ng-template>
} @else {
  <lib-departments-flat-list />
}
